import routes from "../../common/api-routes";
import {HttpAuthGet, HttpAuthPost, HttpAuthPut} from "../../../../../core/services/common/HttpRequestBuilder"


const listUser = ( orgUID, page, searchFor, searchVal, limit) => {

    let parameters = {
        org_uid: orgUID,
        page: page,
        searchFor: searchFor,
        searchVal: searchVal,
        limit: limit
    }

    let result = HttpAuthGet(routes.GET_USER_LIST, parameters);
    return result;
}

const createUser = (parameters) => {

    let result = HttpAuthPost(routes.CREATE_USER, parameters);
    return result;
}

const listUserWithNoOrg = () => {
    let query_params = null;
    let result = HttpAuthGet(routes.LIST_USER_WITH_NO_ORG, query_params);
    return result;
}

const viewUser = (parameters) => {
    let query_params = parameters;

    let result = HttpAuthGet(routes.VIEW_USER, query_params);
    return result;
}


const updateUser = (parameters) => {

    let result = HttpAuthPut(routes.UPDATE_USER, parameters);
    return result;
}

const listUserFilter = (parameters) => {
    let result = HttpAuthGet(routes.LIST_USER_FILTER, parameters);
    return result;
}

const listAllUsersForDropdown = (parameters) => {
    let result = HttpAuthGet(routes.LIST_ALL_USER_FOR_DROPDOWN, parameters);
    return result;
}




const UserService = {
    listUser,
    createUser,
    listUserWithNoOrg,
    viewUser,
    updateUser,
    listUserFilter,

    listAllUsersForDropdown: listAllUsersForDropdown 
}

export default UserService
